
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/aggregation-functions",
      function () {
        return require("private-next-pages/blog/aggregation-functions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/aggregation-functions"])
      });
    }
  